var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonEdit = function SvgPersonEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "person_edit_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#person_edit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 19v-1.8q0-.85.438-1.562.437-.713 1.162-1.088a14.8 14.8 0 0 1 3.15-1.163A13.8 13.8 0 0 1 12 13a15 15 0 0 1 1.825.113q.9.112 1.8.362l-1.675 1.7q-.5-.075-.975-.125A9 9 0 0 0 12 15a11.6 11.6 0 0 0-2.775.338Q7.85 15.675 6.5 16.35a.97.97 0 0 0-.5.85v.8h6v2H5a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 19m10 1v-1.25q0-.4.162-.762.163-.363.438-.638l4.925-4.925q.225-.225.5-.325a1.6 1.6 0 0 1 .55-.1 1.5 1.5 0 0 1 1.075.45l.925.925q.2.225.313.5.111.275.112.55 0 .274-.1.563a1.34 1.34 0 0 1-.325.512l-4.925 4.925a1.975 1.975 0 0 1-1.4.575H15a.97.97 0 0 1-.713-.288A.97.97 0 0 1 14 20m1.5-.5h.95l3.025-3.05-.45-.475-.475-.45-3.05 3.025zm3.525-3.525-.475-.45.925.925zM12 12q-1.65 0-2.825-1.175T8 8t1.175-2.825T12 4t2.825 1.175T16 8t-1.175 2.825T12 12m0-2q.825 0 1.412-.588Q14 8.826 14 8q0-.824-.588-1.412A1.93 1.93 0 0 0 12 6q-.825 0-1.412.588A1.93 1.93 0 0 0 10 8q0 .825.588 1.412Q11.175 10 12 10"
  }))));
};
export default SvgPersonEdit;